export class PagedResult<T> {

  public totalCount: number;
  public items: T[];
  
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/PagedResult.ts